<hr />

<style>
    hr {
        border-color: #DEDEDE;
        border-width: 2px;
        margin: 38px 0;
    }
</style>
